interface GoogleAnalytics extends Window {
    ga(eventCategory: string, eventTye: string, eventName: string, eventLabel: string, eventText: string): void;
}
declare let window: GoogleAnalytics;
export function addGAEventTracker(displaytext: string): void {
    if (typeof window.ga === 'function') {
        window.ga('send', 'event', 'link', 'click', displaytext);
    }
}

